import { COMPONENT_PLACEMENT_BOTTOM_ONLY, COMPONENT_PLACEMENT_FRONT_AND_TOP, COMPONENT_PLACEMENT_FRONT_ONLY, COMPONENT_PLACEMENT_TOP_ONLY } from '../constants';
import { ComponentCategoriesData } from '../public.types';

export const categoryData: ComponentCategoriesData = [
	{
		id: 'd8baa8a0-e20d-4949-883c-927cb1a10bcf',
		key: 'appliance',
		description: 'Grills',
		rules: {
			action: ['RequiresVenting', 'ShippingPromo'],
			validation: []
		},
		sort: 2,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_AND_TOP
	},
	{
		id: '573d5e2e-94a4-4477-b39a-9e7ef8d613e5',
		key: 'appliance',
		description: 'Side Burners',
		rules: {
			action: ['RequiresVenting', 'ShippingPromo'],
			validation: []
		},
		sort: 2,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_AND_TOP
	},
	{
		id: '40c0ea31-73aa-4f85-8998-e35420982903',
		key: 'appliance',
		description: 'Fridges',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 5,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_BOTTOM_ONLY
	},
	{
		id: '0f40045e-df99-4ca8-9276-d0db296e00b0',
		key: 'appliance',
		description: 'Drop-In Coolers',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 5,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_TOP_ONLY
	},
	{
		id: 'd6fad411-b371-4f19-9beb-c8cc9dddc845',
		key: 'appliance',
		description: 'Refreshment Centers',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 5,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_AND_TOP
	},
	{
		id: 'd0dcc608-12c1-448b-b076-87954b1251a0',
		key: 'appliance',
		description: 'Pull-Out Ice Chests',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 5,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: '4b2535fc-1987-4c5f-87cf-33b94913d9f0',
		key: 'appliance',
		description: 'Drop-In Sinks',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 6,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_TOP_ONLY
	},
	{
		id: '44352951-78c1-411f-9d1d-415e7685b3fd',
		key: 'appliance',
		description: 'Farmhouse Sinks',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 6,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_AND_TOP
	},
	{
		id: '28931822-e0bc-4f18-9f46-9241a4f19c9f',
		key: 'appliance',
		description: 'Access Doors',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 7,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: 'cfd2045d-a836-4cd5-b6de-a8e7b4dca003',
		key: 'appliance',
		description: 'Combo Door/Drawer Units',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 8,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: '31238956-2b17-472a-9c76-da376d170e05',
		key: 'appliance',
		description: 'Storage Drawers',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 9,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: '5c178a16-b5f8-4968-ac60-c07d2dffe222',
		key: 'appliance',
		description: 'Accessories',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 12,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: 'c5951b77-4199-477b-b75a-af8d2fcdca0f',
		key: 'insulated-jacket',
		description: 'Insulated Jacket',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 11,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_AND_TOP
	},
	{
		id: '19f0b384-b8de-43ab-9589-0b6d38d206bd',
		key: 'appliance',
		description: 'Warming Drawers',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 6,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: 'ac2bed1d-6713-474f-ba92-4aeb464ef28f',
		key: 'appliance',
		description: 'Trash',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 10,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: '92587138-1aab-4372-94b8-bc87e8cdaf28',
		key: 'appliance',
		description: 'Pizza Ovens',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 3,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_TOP_ONLY
	},
	{
		id: '0fead6c5-8d77-4f09-b5c8-ad95e52d52fe',
		key: 'appliance',
		description: 'Smokers',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 4,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_TOP_ONLY
	},
	{
		id: '796bddfe-2031-434d-a9ae-7d24874a0c55',
		key: 'other',
		description: 'Other',
		rules: { action: [], validation: [] },
		sort: 14,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_BOTTOM_ONLY
	},
	{
		id: '914f22bb-f874-4cb0-bebd-4a6d7e170ae5',
		key: 'cutout',
		description: 'Cutouts',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 13,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_BOTTOM_ONLY
	},
	{
		id: '0ce0d179-9b11-4cfa-8305-296a9a82508a',
		key: 'outlet',
		description: 'Outlets',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 17,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: '264fce5b-56c0-4cb1-a672-c34be8b29838',
		key: 'hole',
		description: 'Circular Cutouts',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 18,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_TOP_ONLY
	},
	{
		id: '285cb107-ea18-49f4-9cf6-945305b6193c',
		key: 'system',
		description: 'System (Internal Use Only)',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 15,
		active: false,
		defaultPlacement: null
	},
	{
		id: 'f7219742-5b07-4032-bcd7-0051950e9ce7',
		key: 'vent',
		description: 'Vents (Internal Use Only)',
		rules: { action: ['ShippingPromo'], validation: [] },
		sort: 16,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	},
	{
		id: 'f7219742-5b07-4032-bcd7-0051950eadf5',
		key: 'passthrough',
		description: 'Passthrough (Internal Use Only)',
		rules: { action: [], validation: [] },
		sort: 16,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_BOTTOM_ONLY
	},
	{
		id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
		key: 'spacer',
		description: 'Space Reservations',
		rules: { action: [], validation: [] },
		sort: 17,
		active: true,
		defaultPlacement: COMPONENT_PLACEMENT_TOP_ONLY
	},
	{
		id: 'a1b2c3d4-5e6f-7a8b-9c0d-utility-cut',
		key: 'utility-cutout',
		description: 'Utility Cutout (Internal Use Only)',
		rules: { action: [], validation: [] },
		sort: 19,
		active: false,
		defaultPlacement: COMPONENT_PLACEMENT_FRONT_ONLY
	}
];
